declare const nominal: unique symbol;

export class Nominal<T> {
  // covariant T
  //     A → B is okay when A <: B

  // invariant (T) => T
  //     requires A <: B AND B <: A
  //     effectively: A ≈ B
  private readonly [nominal]!: (_: T) => T;
}
